(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["login_template"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const forgottenPassword =  (() => {
      const init = () => {
        const btn = document.querySelector('[data-forgotten-password-btn]');
        btn.addEventListener('click', handleBtnClick);
      };
      const handleBtnClick = () => {
        const container = document.querySelector('[data-forgotten-password]');
        container.classList.toggle('hidden');
      };
      return { init };
    })();
    forgottenPassword.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const productTemplate = document.querySelector('.product_template');
    const filterFormProduct = document.querySelector('.product-scroll-widget');

    if (productTemplate && filterFormProduct) {
      document.addEventListener('scroll', () => {
        const top = window.pageYOffset || document.documentElement.scrollTop || 0;
        filterFormProduct.classList.toggle('stick', top > 900);
      });
    }

    const accordionEntries = productTemplate ? productTemplate.querySelectorAll('.information-entry') : [];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    accordionEntries.forEach((entry) => {
      const summary = entry.querySelector('.information-summary');
      const content = entry.querySelector('.information-content');

      if (!summary || !content) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (entry.classList.contains('is-opening') || entry.classList.contains('is-closing')) return;

        if (entry.open) {
          entry.classList.add('is-closing');

          window.setTimeout(() => {
            entry.open = false;
            entry.classList.remove('is-closing');
          }, reducedMotion ? 0 : 280);
        } else {
          entry.classList.add('is-opening');
          entry.open = true;

          window.requestAnimationFrame(() => {
            entry.classList.remove('is-opening');
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
